// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"53":"ca94c6f9","4216":"d38d319b","8847":"7b672fd0"}[chunkId] + ".css";
};